import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule, inject, provideAppInitializer} from '@angular/core';
import {IUnleashConfig} from '@ideals/types';
import {FeatureToggleDirective} from './feature-toggle.directive';
import {FeatureToggleService} from './feature-toggle.service';

@NgModule({
  declarations: [FeatureToggleDirective],
  exports: [FeatureToggleDirective],
  imports: [CommonModule],
})
export class FeatureToggleModule {
  static forRoot(config: IUnleashConfig): ModuleWithProviders<FeatureToggleModule> {
    return {
      ngModule: FeatureToggleModule,
      providers: [
        provideAppInitializer(() => inject(FeatureToggleService).initialize(config))
      ],
    };
  }
}
